<template>
  <div></div>
</template>

<script>
import CurrentUserMixin from '@/components/mixins/CurrentUserMixin'

/**
 * This component exists solely to ensure the user is loaded, and then redirect
 * to the user's home page.
 */
export default {
  name: 'Home',
  mixins: [CurrentUserMixin],
  methods: {
    goToUsersHomePage () {
      if (!this.userLoaded) return
      const homepage = this.user.getSetting('homepage', '/routes')
      this.$router.push(homepage)
    }
  },
  watch: {
    userLoaded: function (newState, oldState) {
      this.goToUsersHomePage()
    }
  },
  mounted () {
    this.goToUsersHomePage()
  }
}
</script>
